import type * as React from 'react';
import { useFragment } from 'react-relay';
import { performanceByYearLineItemFragment } from './PerformanceByYearLineItem.relay';
import type { PerformanceByYearLineItemPropsType } from './types';

const PerformanceByYearLineItem: React.FC<PerformanceByYearLineItemPropsType> = (props) => {
  const data = useFragment(performanceByYearLineItemFragment, props.component);

  const { period, development } = data;

  return (
    <div className="mt-[5px] flex items-start justify-between border-b border-page-bg py-[3px]">
      <div className="text-base text-accent max-[700px]:text-sm">{period}</div>
      <div className="text-right text-[15px] text-black">{`${(development * 100.0).toFixed(2)}%`}</div>
    </div>
  );
};

export { PerformanceByYearLineItem };
